<template>
  <el-cascader
    v-bind="$attrs"
    v-on="$listeners"
    :style="{ width: $attrs.innerWidth || '' }"
  >
    <template slot-scope="{ node, data }">
      <slot>
        <my-tooltip placement="top" :content="($attrs.props && data[$attrs.props.label]) || data.label">
          <div>
            {{($attrs.props && data[$attrs.props.label]) || data.label}}
          </div>
        </my-tooltip>
      </slot>
    </template>
  </el-cascader>
</template>

<script>
  export default {
    name: "tip-cascader",
    components: {},
    watch: {},
    mounted() {
    },
  };
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/TipCascader.vue